/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeliveryRecordFromJSON, DeliveryRecordToJSON } from './DeliveryRecord';
/**
 * Check if a given object implements the DeliveriesResponse interface.
 */
export function instanceOfDeliveriesResponse(value) {
    if (!('deliveries' in value) || value['deliveries'] === undefined)
        return false;
    return true;
}
export function DeliveriesResponseFromJSON(json) {
    return DeliveriesResponseFromJSONTyped(json, false);
}
export function DeliveriesResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'deliveries': (json['deliveries'].map(DeliveryRecordFromJSON)),
    };
}
export function DeliveriesResponseToJSON(json) {
    return DeliveriesResponseToJSONTyped(json, false);
}
export function DeliveriesResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'deliveries': (value['deliveries'].map(DeliveryRecordToJSON)),
    };
}
